window.addEventListener('load', () => {
    const imageSection = document.querySelectorAll('.image-with-pins');

    if(imageSection.length < 0) return;

    imageSection.forEach(section => {
        section.addEventListener('click', (e) => {
            if(e.target.classList.contains('image-with-pins__pin-btn') && !e.target.parentNode.classList.contains('active')) {
                section.querySelector('.image-with-pins__pin.active')?.classList.remove('active');
                e.target.parentNode.classList.add('active');
            } else {
                section.querySelector('.image-with-pins__pin.active')?.classList.remove('active');
            }
        })
    });
});

setTimeout(function() {
  let image_fields = document.querySelectorAll('.field_6809e008757ef')

  image_fields.forEach(function(image) {
    let map = image
    let mapWidth = map.offsetWidth
    let mapHeight = map.offsetHeight
    let label = map.querySelector('.acf-label')
    let inputLeftCordinate = image.parentElement.querySelector('.field_67bc5e2c2faf3 input')
    let inputTopCordinate = image.parentElement.querySelector('.field_67bc5e072faf2 input')

    label.style.left = inputLeftCordinate.value + '%';
    label.style.top = inputTopCordinate.value + '%';

    map.addEventListener('click', function(e) {
      let leftCordinate = e.offsetX
      let topCoordinate = e.offsetY

      let leftCordinatePercent = Math.round((leftCordinate * 100) / mapWidth)
      let topCoordinatePercent = Math.round((topCoordinate * 100) / mapHeight)

      inputLeftCordinate.value = leftCordinatePercent
      inputTopCordinate.value = topCoordinatePercent

      const event = new Event('change', { bubbles: true });
      inputLeftCordinate.dispatchEvent(event);
      inputTopCordinate.dispatchEvent(event);

      label.style.left = leftCordinatePercent + '%';
      label.style.top = topCoordinatePercent + '%';
    })
  })
}, 1000)

